// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2W1um","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2e5xf"};